import { render, staticRenderFns } from "./NotesDefault.vue?vue&type=template&id=57d13b70&"
import script from "./NotesDefault.vue?vue&type=script&lang=js&"
export * from "./NotesDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports